
import PokerTableMySeatPokers from "../../../table/module/poker_table/poker_myseat_pokers";
import PromiseUtility from "../../../../utility/promiseUtility";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import Utility from "../../../../utility/utility";
import { Card } from "./q2_card_common";
const { ccclass, property, menu } = cc._decorator;


@ccclass
export default class Q2MySeatCardsBase extends PokerTableMySeatPokers{

    @property(cc.Float)
    defaultAdjustDuration: number = 0.2

    showPokers(show: boolean, codeList?: number[], params?: any): cc.Vec2{
        let self = this        
        this.unscheduleAllCallbacks()
        this.removeAllPokers()        
        if(show){
            let pokerList = this.genPokerList(codeList, false)
            for (let index = 0; index < pokerList.length; index++) {
                let poker = pokerList[index]    
                poker.show()
                if(params){
                    if(params.hidePoker){
                        poker.hide()
                    }
                }                         
                poker.showFace(true)                
            }
            let targetCount = 0
            if(params && params){
                targetCount = params.targetLayoutCount
            }
            let centerLocalPos = this.formatPokersLayout(pokerList, targetCount)
    
            if(params){
                if(params.playAdjustAnim){
                    self.playAdjustAnim(pokerList, pokerList.length, params.duration, params.delay, function(){
                        self.showPokers(true, codeList)
                        params.onFinishPlayAdjustAnim && params.onFinishPlayAdjustAnim()
                    }, null, null, null, true)
                }
            }

            let worldPos = this.nodePokersParent.convertToWorldSpaceAR(centerLocalPos)
            return worldPos
        }
        return cc.Vec2.ZERO
    }

    disabledAllPokers(){
        let disabledPokers = []
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            poker.disabled = true
            disabledPokers.push(poker)
        }
        return disabledPokers
    }

    enablePokers(codeList: number[], idList?: number[]){
        let enabledPokers = []
        let waitenabledCodeCountTable = []
        let enabledCodeCountTable = []
        let pokers = this.pokers
        let useIdFind = false
        let tmpList = codeList
        if(idList && idList.length > 0){
            useIdFind = true
            tmpList = idList
        }
        for (let i = 0; i < tmpList.length; i++) {
            let index = tmpList[i];
            if(!useIdFind){
                index = Card.codeToLogicCode(index)
            }
            if(!waitenabledCodeCountTable[index]){
                waitenabledCodeCountTable[index] = 0
            }
            waitenabledCodeCountTable[index] = waitenabledCodeCountTable[index] + 1
            enabledCodeCountTable[index] = 0
        }
        this.disabledAllPokers()
        for (let i = 0; i < tmpList.length; i++) {
            let index = tmpList[i]
            if(!useIdFind){
                index = Card.codeToLogicCode(index)
            }
            for (let j = 0; j < pokers.length; j++) {
                const poker = pokers[j];
                let pokerIndex = poker.code
                if(useIdFind){
                    pokerIndex = poker.id
                }else{
                    pokerIndex = Card.codeToLogicCode(pokerIndex)
                }
                if(pokerIndex == index && (poker.disabled)){
                    if(waitenabledCodeCountTable[index] > enabledCodeCountTable[index]){
                        enabledCodeCountTable[index] = enabledCodeCountTable[index] + 1
                        poker.disabled = false
                        enabledPokers.push(poker)
                    }
                }
            }
        }
        return enabledPokers
    }

    playAdjust(duration?: number, onFinish?: Function, ignoreNodeList?: cc.Node[], stopLastAnim?: boolean, ignorePosY?: boolean, customCalcPosFun?: Function){
        duration = duration || this.defaultAdjustDuration
        let self = this
        let pokers = self.pokers
        self.playAdjustAnim(pokers, pokers.length, duration, 0, null, ignoreNodeList, null, stopLastAnim, ignorePosY, customCalcPosFun)
        if(onFinish){
            self.scheduleOnce(function(){
                onFinish()
            }, duration)
        }
    }

    protected playAdjustAnim(pokerList: PokerTablePokerBase[], targetCount: number, duration: number, delay?: number,  easingType?, ignoreNodeList?: cc.Node[], onStart?: Function, stopLastAnim?: boolean, ignorePosY?: boolean, customCalcPosFun?: Function){
        let self = this
        if(targetCount == 0){
            return
        }
        let isIgnoreNode = function(node: cc.Node){
            if(ignoreNodeList){
                for (let index = 0; index < ignoreNodeList.length; index++) {
                    const tmp = ignoreNodeList[index];
                    if(tmp == node){
                        return true
                    }
                }
            }
            return false
        }
        for (let index = 0; index < pokerList.length; index++) {
            const poker = pokerList[index];
            let node = poker.node
            if(isIgnoreNode(node)){
                continue
            }
            let data = customCalcPosFun? customCalcPosFun(index, targetCount): self.getPosData(index, targetCount)
            let targetPos = data.localPos.clone()
            if(ignorePosY){
                poker.original_pos.x = data.localPos.x
                targetPos.y = node.position.y
            }else{
                poker.original_pos = data.localPos
            }                                    
            node.zIndex = data.zIndex
            self.playNodeAnim(node, targetPos, null, duration, delay, easingType, null, null, stopLastAnim)
        }

    }

    protected playNodeAnim(node: cc.Node, targetPos: cc.Vec2, targetScale: cc.Vec2, duration: number, delay?: number, easingType?, onFinish?: Function, onStart?: Function, stopLastAnim?: boolean){
        let self = this          
        let do_fun = function(){
            onStart && onStart()
            let animList = []
            let moveAnim = cc.moveTo(duration, targetPos) 
            animList.push(moveAnim)            
            if(targetScale){
                let scaleAnim = cc.scaleTo(duration, targetScale.x, targetScale.y)                
                if(easingType){
                    scaleAnim = scaleAnim.easing(easingType)
                }
                animList.push(scaleAnim)
            }
            if(easingType){
                moveAnim = moveAnim.easing(easingType)
            }
            let tmpFun = function(){     
                node['_domove_targetpos'] = null
                onFinish && onFinish()
            }.bind(self)
            let callFun = cc.callFunc(tmpFun)                            
            let lastTargetPos = node['_domove_targetpos']
            if(!stopLastAnim && lastTargetPos && targetPos.equals(lastTargetPos)){                
                return
            }
            node['_domove_targetpos'] = targetPos
            if(animList.length > 1){
                animList = [cc.spawn(animList)]
            }
            animList.push(callFun)            
            var seq = cc.sequence(animList)            
            node.active = true
            seq.setTag(1)
            node.stopActionByTag(1)
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }

    protected playFadeAnim(node: cc.Node, from: number, to: number, duration: number, delay?: number, onFinish?: Function){
        let self = this
        let do_fun = function(){
            node.opacity = from
            let fadeAnim = cc.fadeTo(duration, to)
            let tmpFun = function(){
                node.opacity = to
                onFinish && onFinish()
            }.bind(self)
            let callFun = cc.callFunc(tmpFun)
            node.active = true
            var seq = cc.sequence([fadeAnim, callFun])
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }

    protected formatPokersLayout(pokerList: PokerTablePokerBase[], targetCount?: number): cc.Vec2{
        if(!pokerList || pokerList.length == 0){
            return cc.Vec2.ZERO
        }
        targetCount = targetCount || pokerList.length                
        for (let i = 0; i < pokerList.length; i++) {
            let poker = pokerList[i];          
            let data = this.getPosData(i, targetCount)
            let localPos = poker.node.parent.convertToNodeSpaceAR(data.worldPos)
            poker.node.position = localPos
            poker.original_pos = localPos
            poker.node.zIndex = data.zIndex
        }
        return cc.Vec2.ZERO
    }

    protected calcLayoutPosAndPriority(len: number){
        let dataList = []
        for (let index = 0; index < len; index++) {
            let pos = this.calcPos(index, 0, len, 1)
            let col = index
            let row = 0
            let priority = index
            dataList.push({pos: pos, col: col, row: row, priority: priority})
        }
        return {dataList:dataList, centerPos: cc.Vec2.ZERO}
    }

    protected getPosData(index: number, count: number){
        let posAngle = this.calcPosAndAngle(index, count)
        let data: any = {}
        data.localPos = posAngle.localPos
        data.worldPos = this.nodePokersParent.convertToWorldSpaceAR(data.localPos)
        data.zIndex = posAngle.zIndex
        return data
    }

    protected calcPosAndAngle(index: number, count: number){        
        let localPos = this.calcPos(index, 0, count, 1)        
        return {localPos: localPos, zIndex: index}
    }

    protected sortCodeListByIndex(codeList: number[]){
        codeList.sort(function(a, b){
            let aIndex = Card.codeToIndex(a)
            let bIndex = Card.codeToIndex(b)
            if(aIndex == bIndex){
                let aColor = Card.codeToColor(a)
                let bColor = Card.codeToColor(b)
                return aColor - bColor
            }
            return aIndex - bIndex
        })
    }

    protected check_drag_mark_singel(poker: PokerTablePokerBase, isLeftPokersUnMark: boolean, startPoker: PokerTablePokerBase): 
    {isLeftPokersUnMark: boolean, startPoker: PokerTablePokerBase}{
        if(isLeftPokersUnMark){
            poker.marked = false
        }else{
            if(poker == this.mFirstHoverPoker){
                poker.marked = true               
            }else{
                poker.marked = false
            }
        }
        return {isLeftPokersUnMark: isLeftPokersUnMark, startPoker: startPoker}
    }

    selectPokers(codeList: number[], idList: number[]){
        let selectPokers = []
        let waitSelectedCodeCountTable = []
        let selectedCodeCountTable = []
        let pokers = this.pokers
        let useIdFind = false
        let tmpList = codeList
        if(idList && idList.length > 0){
            useIdFind = true
            tmpList = idList
        }
        for (let i = 0; i < tmpList.length; i++) {
            let index = tmpList[i];
            if(!useIdFind){
                index = Card.codeToLogicCode(index)
            }
            if(!waitSelectedCodeCountTable[index]){
                waitSelectedCodeCountTable[index] = 0
            }
            waitSelectedCodeCountTable[index] = waitSelectedCodeCountTable[index] + 1
            selectedCodeCountTable[index] = 0
        }
        this.selectAllPokers(false)
        for (let i = 0; i < tmpList.length; i++) {
            let index = tmpList[i]
            if(!useIdFind){
                index = Card.codeToLogicCode(index)
            }
            for (let j = 0; j < pokers.length; j++) {
                const poker = pokers[j];
                let pokerIndex = poker.code
                if(useIdFind){
                    pokerIndex = poker.id
                }else{
                    pokerIndex = Card.codeToLogicCode(pokerIndex)
                }
                if(pokerIndex == index && (!poker.selected)){
                    if(waitSelectedCodeCountTable[index] > selectedCodeCountTable[index]){
                        selectedCodeCountTable[index] = selectedCodeCountTable[index] + 1
                        poker.selected = true
                        poker.selected_time = this.genTimeSelectIndex()
                        selectPokers.push(poker)
                    }
                }
            }
        }
        return selectPokers
    }

    refreshPokerDisableState(){
        super.refreshPokerDisableState()
        let pokers = this.pokers
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            this.setPokerGrayColor(poker, poker.disabled)
        }
    }

    protected refreshPokersMarkState(){
        
    }

    getCodeList(){
        let pokers = this.pokers
        let codeList = []
        for (let index = 0; index < pokers.length; index++) {
            const element = pokers[index];
            codeList.push(element.code)
        }
        return codeList
    }

    protected checkAndDealCallback(node: cc.Node){
        let self = this
        let lastFun = self.getNodeActionCallback(node)            
        if(lastFun){
            lastFun()
            return self.checkAndDealCallback(node)
        }  
    }

    protected setNodeActionCallback(node: cc.Node, callback: Function){
        node['_action_callback'] = callback
    }    

    protected getNodeActionCallback(node: cc.Node){
        return node['_action_callback']
    }
}
